
import { clientType, categoryType, productType } from './types';

export const localInfo: clientType = {
    name: "Kaktus & Co.",
    description: "🌵Plant-Based Food",
    instagram: "https://www.instagram.com/kaktus_uy",
    slug: "kaktus",
    heading: "Bienvenido(a) a Kaktus tenemos <span>descuentos especiales!</span>",
    sub_heading: "Envios gratis todos los días",
    address: "Av. Gral. Rivera 2951 (Delivery & Take Away)",
    address_link: "https://www.google.com/maps/place//data=!4m2!3m1!1s0x959f8113bffc20a9:0x3c1415fbcb9c62b9?source=g.page.share",
    whatsapp: "59892127071",
    logo: "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Finfo%2Fkaktus_logo.svg?alt=media&token=1c7d3e14-f928-4ba4-b831-81cdbb7981c3",
    isologo: "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Finfo%2Fkaktus_isologo.svg?alt=media&token=6b38bff2-cd56-42c6-a4c1-2910553dace5",
    zones_map: "https://www.google.com/maps/d/u/0/embed?mid=1f2g4RNZ1gpLKTDWubhQZx_ALkLLmJbus",
    about_title: "¿Por que Kaktus?",
    about_text: "Nuestro concepto en kaktus & Co. 🌵 Hace referencia a alimentos 100% basados en plantas, incorporando a su vez, ingredientes frescos, sin conservantes ni aditivos donde predomina la frescura y la variedad de sabores.",
    gallery: ["https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Finfo%2Fkaktus_info_2.jpeg?alt=media&token=718d847d-fa85-41ac-81e7-11b44b426957",
        "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Finfo%2Fkaktus_info_1.jpeg?alt=media&token=c4250d8c-26f6-4c4e-80f0-582b44354fb8",
        "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Finfo%2Fkaktus_info_3.jpeg?alt=media&token=3d9f4170-7088-4763-b1c3-022093c51b34"],
    weekDays: [
        { day: "Sunday", times: [11.30, 0.00] },
        { day: "Monday", times: [11.00, 0.00] },
        { day: "Tuesday", times: [11.00, 0.00] },
        { day: "Wednesday", times: [11.00, 0.00] },
        { day: "Thursday", times: [11.00, 0.00] },
        { day: "Friday", times: [11.00, 0.30] },
        { day: "Saturday", times: [11.30, 0.30] },
    ],
}

export const categories: categoryType[] = [
    {
        name: "Promociones",
        slug: "promociones",
        order: 1,
        image: "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Fmenu%2Fsopa.jpg?alt=media&token=66e4e36d-65c9-4d4c-84f8-4e7a34de607b",
        products: [
        ]
    },
    {
        name: "Principales",
        slug: "principales",
        order: 2,
        image: "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Fprincipales.jpg?alt=media&token=0c9d61ee-bf87-4291-8b9d-0f562da0ccc1",
        products: [
        ]
    },
    {
        name: "Pizzas",
        slug: "pizzas",
        order: 3,
        image: "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Fpizzas-faina.jpg?alt=media&token=85d1d013-0526-4677-9c80-8eb0ee31d93a",
        products: []
    },
    {
        name: "Acompañamientos",
        slug: "acompañantes",
        order: 4,
        image: "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Facompan%CC%83amientos.jpg?alt=media&token=560ec87b-802e-4cd3-8716-f470257a7e75",
        products: []
    },
    {
        name: "Postres",
        slug: "postres",
        order: 5,
        image: "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Fmenu%2Falfajor-brownie.jpg?alt=media&token=0d14b746-1c2a-487e-9887-330cfdda534b",
        products: []
    },
    {
        name: "Bebidas",
        slug: "bebidas",
        order: 6,
        image: "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Fbebidas.jpg?alt=media&token=6d86be8b-6465-4343-a886-7e306d289608",
        products: []
    },
]

export const products: productType[] =
    [
        {
            "price": 95,
            "image": "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Fmenu%2Falfajor-brownie.jpg?alt=media&token=0d14b746-1c2a-487e-9887-330cfdda534b",
            "description": "",
            "name": "Alfajor de brownie y crema de maní",
            "category": "postres",
            "slug": "alfajor-brownie"
        },
        {
            "name": "Aros de Cebolla",
            "image": "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Facompan%CC%83amientos.jpg?alt=media&token=560ec87b-802e-4cd3-8716-f470257a7e75",
            "price": 120,
            "slug": "aros-cebolla",
            "category": "acompañantes",
            "description": "Para acompañar o picar"
        },
        {
            "name": "BBQ",
            "description": "Salsa, queso vegarella, proteína vegetal y salsa BBQ",
            "category": "pizzas",
            "slug": "bbq",
            "price": 440,
            "image": ""
        },
        {
            "options": [
                {
                    "name": "Proteina",
                    "multiple": false,
                    "required": true,
                    "optionItems": [
                        {
                            "price": 0,
                            "name": "Garbanzos",
                            "selected": true
                        },
                        {
                            "name": "Lentejas",
                            "price": 0
                        },
                        {
                            "price": 0,
                            "name": "Zanahoria y Puerro"
                        }
                    ]
                },
                {
                    "max": 5,
                    "name": "Salsas",
                    "required": false,
                    "multiple": true,
                    "optionItems": [
                        {
                            "name": "Veganesa",
                            "price": 0
                        },
                        {
                            "price": 0,
                            "name": "Ketchup"
                        },
                        {
                            "name": "Mostaza",
                            "price": 0
                        },
                        {
                            "price": 0,
                            "name": "BBQ"
                        }
                    ]
                },
                {
                    "name": "Toppings",
                    "max": 5,
                    "optionItems": [
                        {
                            "name": "Lechuga",
                            "price": 0
                        },
                        {
                            "price": 0,
                            "name": "Tomate"
                        },
                        {
                            "name": "Cebolla",
                            "price": 0
                        },
                        {
                            "price": 0,
                            "name": "Pepinillos"
                        },
                        {
                            "name": "Papas Pay",
                            "price": 0
                        }
                    ],
                    "multiple": true,
                    "required": false
                },
                {
                    "required": false,
                    "optionItems": [
                        {
                            "name": "Papas Fritas",
                            "price": 0
                        },
                        {
                            "name": "Aros de cebolla",
                            "price": 0
                        },
                        {
                            "name": "Mini Salad",
                            "price": 0
                        },
                        {
                            "price": 30,
                            "name": "Mix papas y Boniatos"
                        }
                    ],
                    "multiple": true,
                    "name": "Acompañamientos",
                    "max": 5
                }
            ],
            "name": "Burger",
            "image": "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Fburger_vegan.webp?alt=media&token=dafc8e72-8e53-4cd9-82c5-4c9f6b51f63c",
            "slug": "burger",
            "price": 360,
            "description": "Lentejas, Garbanzos o Zanahoria y Puerro",
            "category": "principales"
        },
        {
            "category": "pizzas",
            "price": 440,
            "slug": "capresse",
            "name": "Capresse",
            "image": "",
            "description": "Salsa, queso vegarella, tomate y albahaca"
        },
        {
            "description": "Ideal para el invierno",
            "name": "Cazuela lentejas / Cazuela Leguminosas",
            "price": 149,
            "image": "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Fmenu%2Fcazuela.jpg?alt=media&token=06aa2067-def4-4275-ad3a-29f13a1fe70e",
            "category": "promociones",
            "slug": "cazuela",
            "options": [
                {
                    "name": "Tipo de cazuela",
                    "optionItems": [
                        {
                            "price": 0,
                            "name": "Cazuela lentejas"
                        },
                        {
                            "name": "Cazuela Leguminosas",
                            "price": 0
                        }
                    ],
                    "multiple": false,
                    "required": true
                }
            ],
        },
        {
            "image": "",
            "slug": "choco-cookie",
            "category": "postres",
            "price": 70,
            "description": "Galleta de chocolate",
            "name": "Choco-cookie"
        },
        {
            "image": "",
            "description": "Salsa, queso vegarella, tomate y rúcula",
            "name": "De la huerta",
            "category": "pizzas",
            "slug": "de-la-huerta",
            "price": 440
        },
        {
            "description": "",
            "category": "pizzas",
            "name": "Fainá",
            "image": "",
            "price": 110,
            "slug": "faina"
        },
        {
            "name": "Papas Fritas Onduladas",
            "slug": "fritas-onduladas",
            "price": 120,
            "image": "",
            "category": "acompañantes",
            "description": "Ricas fritas onduladas"
        },
        {
            "name": "Coca Cola o Sprite",
            "slug": "gaseosa-lata",
            "price": 80,
            "category": "bebidas",
            "image": "",
            "description": "Lata (regular, s/azúcar / sprite s/azúcar)",
            "options": [
                {
                    "multiple": false,
                    "optionItems": [
                        {
                            "price": 0,
                            "name": "Coca Regular"
                        },
                        {
                            "price": 0,
                            "name": "Coca Sin Azucar"
                        },
                        {
                            "name": "Sprite Sin Azucar",
                            "price": 0
                        }
                    ],
                    "required": true,
                    "name": "Tipo"
                }
            ]
        },
        {
            "image": "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Fmenu%2Fgreek-gyro.jpg?alt=media&token=a8b00422-70a1-4b2e-bdbf-134d37e88ee4",
            "description": "Pan Griego relleno de proteína vegetal con especias, lechuga, tomate, papas fritas, cebolla paprika y salsa tzatziki",
            "slug": "greek-gyro",
            "name": "Vegan Greek Gyro",
            "price": 210,
            "category": "principales"
        },
        {
            "price": 290,
            "description": "",
            "name": "Hot Dog",
            "image": "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Fmenu%2Fhotdog.jpg?alt=media&token=914ddd34-79b4-4655-a755-4724ebc0c4a3",
            "slug": "hotdog",
            "options": [
                {
                    "required": false,
                    "optionItems": [
                        {
                            "price": 0,
                            "name": "Veganesa"
                        },
                        {
                            "name": "Ketchup",
                            "price": 0
                        },
                        {
                            "name": "Mostaza",
                            "price": 0
                        },
                        {
                            "name": "BBQ",
                            "price": 0
                        }
                    ],
                    "max": 5,
                    "multiple": true,
                    "name": "Salsas"
                },
                {
                    "required": false,
                    "name": "Toppings",
                    "max": 5,
                    "multiple": true,
                    "optionItems": [
                        {
                            "name": "Lechuga",
                            "price": 0
                        },
                        {
                            "name": "Tomate",
                            "price": 0
                        },
                        {
                            "price": 0,
                            "name": "Cebolla"
                        },
                        {
                            "name": "Pepinillos",
                            "price": 0
                        },
                        {
                            "name": "Papas Pay",
                            "price": 0
                        }
                    ]
                },
                {
                    "required": false,
                    "name": "Acompañamientos",
                    "optionItems": [
                        {
                            "name": "Papas Fritas",
                            "price": 0
                        },
                        {
                            "name": "Aros de cebolla",
                            "price": 0
                        },
                        {
                            "name": "Mini Salad",
                            "price": 0
                        },
                        {
                            "price": 30,
                            "name": "Mix papas y Boniatos"
                        }
                    ],
                    "max": 5,
                    "multiple": true
                }
            ],
            "category": "principales"
        },
        {
            "description": "Con acompañamiento",
            "slug": "mila-soja",
            "image": "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Fmenu%2Fmila-soja.jpg?alt=media&token=ce49b4cf-0080-4cfc-aa26-a69d2fa2853b",
            "category": "principales",
            "price": 290,
            "options": [
                {
                    "name": "Acompañamientos",
                    "optionItems": [
                        {
                            "name": "Papas Fritas",
                            "price": 0
                        },
                        {
                            "name": "Aros de cebolla",
                            "price": 0
                        },
                        {
                            "price": 0,
                            "name": "Mini Salad"
                        },
                        {
                            "name": "Mix papas y Boniatos",
                            "price": 30
                        }
                    ],
                    "max": 5,
                    "multiple": true,
                    "required": false
                }
            ],
            "name": "Milanesa de Soja"
        },
        {
            "image": "",
            "description": "Porción para acompañar",
            "category": "acompañantes",
            "slug": "mini-salad",
            "name": "Mini Salad",
            "price": 30
        },
        {
            "slug": "mix-papas",
            "description": "",
            "category": "acompañantes",
            "image": "",
            "price": 120,
            "name": "Mix Papas y Boniatos"
        },
        {
            "slug": "oliva",
            "name": "Oliva",
            "image": "",
            "price": 440,
            "category": "pizzas",
            "description": "Salsa, queso vegarella y olivas"
        },
        {
            "slug": "faina",
            "name": "Fainá",
            "image": "",
            "price": 110,
            "category": "pizzas",
            "description": "Fainá de la casa"
        },
        {
            "description": "Ideal para el invierno",
            "image": "https://firebasestorage.googleapis.com/v0/b/ronaldux-f5e97.appspot.com/o/kaktus%2Fmenu%2Fsopa.jpg?alt=media&token=66e4e36d-65c9-4d4c-84f8-4e7a34de607b",
            "price": 149,
            "slug": "sopa",
            "category": "promociones",
            "name": "Sopa de Invierno"
        },
        {
            "price": 410,
            "name": "Vegan cheese",
            "slug": "vegan-cheese",
            "image": "",
            "category": "pizzas",
            "description": "Salsa y queso vegarella"
        },
        {
            "slug": "vegan-wrap",
            "price": 290,
            "image": "",
            "category": "principales",
            "description": "Pan Griego relleno de proteína vegetal con especias, lechuga, tomate, papas fritas, cebolla paprika y salsa tzatziki",
            "name": "Vegan Wrap + guarnición",
            "options": [
                {
                    "required": false,
                    "name": "Acompañamientos",
                    "optionItems": [
                        {
                            "name": "Papas Fritas",
                            "price": 0
                        },
                        {
                            "name": "Aros de cebolla",
                            "price": 0
                        },
                        {
                            "name": "Mini Salad",
                            "price": 0
                        },
                        {
                            "price": 30,
                            "name": "Mix papas y Boniatos"
                        }
                    ],
                    "max": 5,
                    "multiple": true
                }
            ],

        },
        {
            "name": "Vegetariana",
            "slug": "vegetariana",
            "price": 440,
            "category": "pizzas",
            "description": "Salsa, queso vegarella, olivas, cebolla, pimientos y hongos",
            "image": ""
        },
        {
            "category": "bebidas",
            "name": "Cerveza Volcanica 500cc",
            "description": "IPA o Blonde",
            "price": 180,
            "options": [
                {
                    "multiple": false,
                    "optionItems": [
                        {
                            "name": "IPA",
                            "price": 0
                        },
                        {
                            "price": 0,
                            "name": "Blonde"
                        }
                    ],
                    "required": true,
                    "name": "Tipo"
                }
            ],
            "slug": "volcanica-blonde",
            "image": ""
        }
    ]


export const jdMenuBM: productType[] = [
    {
        "name": "Ensalada Cesar",
        "description": "Variedad de lechuga, parmesano, croutones de pan, pollo a la plancha en tiras y aderezo César de la casa.",
        "slug": "ensalada-cesar",
        "price": 278,
        "image": "cesar.jpg",
        "category": "Especiales",
        "discount": 10
    },
    {
        "name": "Egg & cheese sandwich",
        "description": "",
        "slug": "egg--cheese-sandwich",
        "price": 133,
        "image": "egg_sandwich.jpg",
        "category": "Especiales",
        "discount": 10
    },
    {
        "name": "Porción de Papas Fritas 250g",
        "description": "",
        "slug": "porcin-de-papas-fritas-250g",
        "price": 133,
        "image": "papas.jpg",
        "category": "Fritas",
        "discount": 10
    },
    {
        "name": "Porción de Aros de Cebolla",
        "description": "",
        "slug": "porcin-de-aros-de-cebolla",
        "price": 133,
        "image": "np.jpg",
        "category": "Fritas",
        "discount": 10
    },
    {
        "name": "Mix de papas y boniatos",
        "description": "",
        "slug": "mix-de-papas-y-boniatos",
        "price": 133,
        "image": "np.jpg",
        "category": "Fritas",
        "discount": 10
    },
    {
        "name": "Vegetariana",
        "description": "Champiñones, pimientos, cebolla y aceitunas",
        "slug": "vegetariana",
        "price": 489,
        "image": "pizza_vegetariana.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "De La Huerta",
        "description": "Tomates, Provolone, rúcula, parmesano y aceite de oliva.",
        "slug": "de-la-huerta",
        "price": 489,
        "image": "de_la_huerta.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Sweet Chilly",
        "description": "Pollo, Salsa Sweet Chilly (Levemente Picante) y verdeo.",
        "slug": "sweet-chilly",
        "price": 489,
        "image": "sweet_chilly.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Tomatito",
        "description": "Salsa de Tomate",
        "slug": "tomatito",
        "price": 417,
        "image": "tomatito.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "4 Quesos",
        "description": "Queso crema, Muzzarella, Cheddar,  Parmesano (Sin salsa de tomate)",
        "slug": "4-quesos",
        "price": 489,
        "image": "4_quesos.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "BBQ chicken bacon",
        "description": "Pollo con Salsa BBQ, panceta y cebolla",
        "slug": "bbq-chicken-bacon",
        "price": 489,
        "image": "bbq.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Capresse",
        "description": "Muzzarella, tomate y albahaca",
        "slug": "capresse",
        "price": 489,
        "image": "pizza_capresse.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Forte",
        "description": "Muzzarella, jamón, panceta y pepperoni.",
        "slug": "forte",
        "price": 489,
        "image": "forte.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Hawaina",
        "description": "Jamón en Cubos y Piña Natural.",
        "slug": "hawaina",
        "price": 489,
        "image": "hawaiana.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Oliva",
        "description": "Muzzarella y Aceitunas",
        "slug": "oliva",
        "price": 489,
        "image": "oliva.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Sprite Zero 600cc",
        "description": " 600 cc",
        "slug": "sprite-zero-600cc",
        "price": 80,
        "image": "sprite_zero.png",
        "category": "Bebidas"
    },
    {
        "name": "Philly Cheesesteak",
        "description": "Muzzarella, provolone, cebolla y carne braseada en IPA",
        "slug": "philly-cheesesteak",
        "price": 489,
        "image": "np.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Fugazzetta",
        "description": "Sin salsa de Tomate, Muzzarella, cebolla y orégano.",
        "slug": "fugazzetta",
        "price": 489,
        "image": "fugazzetta.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Alabama Burger",
        "description": "Doble Smash de carne con cheddar Cebolla Caramelizada Panceta Salsa BBQ",
        "slug": "alabama-burger",
        "price": 322,
        "image": "alabama.jpg",
        "category": "Burgers",
        "discount": 10
    },
    {
        "name": "Fritas cheddar & panceta",
        "description": "Una porción de papas fritas de 350 g con cheddar y panceta.",
        "slug": "fritas-cheddar--panceta",
        "price": 311,
        "image": "papas_cheddar.jpg",
        "category": "Fritas",
        "discount": 10
    },
    {
        "name": "Vegan Burger",
        "description": "Opciones: Garbanzos/ Zanahoria y puerro / Lentejas",
        "slug": "vegan-burger",
        "price": 322,
        "image": "veggie.jpg",
        "category": "Burgers",
        "discount": 10
    },
    {
        "name": "Paprika Lovers",
        "description": "Champiñones, Pepperoni y Paprika.",
        "slug": "paprika-lovers",
        "price": 489,
        "image": "paprika_lovers.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Cheese",
        "description": "Muzzarella y Orégano",
        "slug": "cheese",
        "price": 417,
        "image": "cheese.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Choco-Cookie",
        "description": "",
        "slug": "choco-cookie",
        "price": 56,
        "image": "cookie.jpg",
        "category": "Postres",
        "discount": 10
    },
    {
        "name": "Doble salchichon relleno",
        "description": "",
        "slug": "doble-salchichon-relleno",
        "price": 89,
        "image": "salchichon.jpg",
        "category": "Postres",
        "discount": 10
    },
    {
        "name": "Arizona Burger",
        "description": "Doble Smash de carne con cheddar Lechuga Tomate Mayonesa Salsa Criolla",
        "slug": "arizona-burger",
        "price": 322,
        "image": "arizona.jpg",
        "category": "Burgers",
        "discount": 10
    },
    {
        "name": "Gyro JD",
        "description": "De carne o pollo con lechuga, tomate, panceta, papas pay y guarnición opcional de (Papas fritas, aros de cebolla o mix de papas y boniatos)",
        "slug": "gyro-jd",
        "price": 356,
        "image": "np.jpg",
        "category": "Especiales",
        "discount": 10
    },
    {
        "name": "Deliciosa",
        "description": "Panceta y Gotas de Queso Cheddar.",
        "slug": "deliciosa",
        "price": 489,
        "image": "deliciosa.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Oklahoma Style",
        "description": "Doble Smash de carne con cheddar Cebolla salteada Pepinillos Mostaza Salsa Ketchup",
        "slug": "oklahoma-style",
        "price": 322,
        "image": "oklahoma.jpg",
        "category": "Burgers",
        "discount": 10
    },
    {
        "name": "Coca Cola Regular 600cc",
        "description": "600 cc",
        "slug": "coca-cola-regular-600cc",
        "price": 80,
        "image": "coca_comun.png",
        "category": "Bebidas"
    },
    {
        "name": "Siesta",
        "description": "Panceta crocante y Huevos fritos.",
        "slug": "siesta",
        "price": 489,
        "image": "siesta.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Peroni",
        "description": "Pepperoni premium, queso muzzarella y orégano.",
        "slug": "peroni",
        "price": 489,
        "image": "peroni.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Lulita's",
        "description": "salsa de tomate, muzzarella, cebolla caramelizada, queso azul y mix de nueces con caramelo",
        "slug": "lulitas",
        "price": 489,
        "image": "lullitas.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Fainá de la Huerta",
        "description": "Muzzarella, tomate, rúcula, parmesano y aceite de oliva.",
        "slug": "fain-de-la-huerta",
        "price": 211,
        "image": "faina_huerta.jpg",
        "category": "Fainá",
        "discount": 10
    },
    {
        "name": "Natalio",
        "description": "Peras, Roquefort, Panceta y Nuez. (Sin salsa de tomate)",
        "slug": "natalio",
        "price": 489,
        "image": "natalio.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Fainá con Muzza",
        "description": "",
        "slug": "fain-con-muzza",
        "price": 144,
        "image": "faina_muzza.jpg",
        "category": "Fainá",
        "discount": 10
    },
    {
        "name": "Indyana Crispy Chicken",
        "description": "Pechuga crispy, rúcula, tomate, parmesano y aderezo especial.",
        "slug": "indyana-crispy-chicken",
        "price": 322,
        "image": "indyanna.jpg",
        "category": "Burgers",
        "discount": 10
    },
    {
        "name": "California Burger",
        "description": "Doble smash de carne con muzzarella, morrones confitados, huevo frito y aderezo a elección",
        "slug": "california-burger",
        "price": 322,
        "image": "indyanna.jpg",
        "category": "Burgers",
        "discount": 10
    },
    {
        "name": "Miami Chesse",
        "description": "Doble smash de carne con panceta, medallon de provolone y aderezo inglés.",
        "slug": "miami-chesse",
        "price": 322,
        "image": "np.jpg",
        "category": "Burgers",
        "discount": 10
    },
    {
        "name": "Coca Cola Light 600cc",
        "description": "600 cc",
        "slug": "coca-cola-light-600cc",
        "price": 80,
        "image": "coca_light.png",
        "category": "Bebidas"
    },
    {
        "name": "Gaseosas 1.5lts",
        "description": "1.5lts",
        "slug": "gaseosas-15lts",
        "price": 160,
        "image": "np.jpg",
        "category": "Bebidas"
    },
    {
        "name": "Wrap JD + Acompañamiento",
        "description": "De carne o pollo con lechuga, tomate cebolla, mayonesa y guarnición opcional de (Papas fritas, aros de cebolla o mix de papas y boniatos)",
        "slug": "wrap-jd--acompaamiento",
        "price": 356,
        "image": "np.jpg",
        "category": "Especiales",
        "discount": 10
    },
    {
        "name": "Boston",
        "description": "Jamón en cubos y pimientos asados.",
        "slug": "boston",
        "price": 489,
        "image": "boston.jpg",
        "category": "Pizzas",
        "discount": 10
    },
    {
        "name": "Fainá",
        "description": "",
        "slug": "fain",
        "price": 122,
        "image": "faina.jpg",
        "category": "Fainá",
        "discount": 10
    }
]

export const menuJDList = [
    {
        "base_price": 250,
        "category": "Especiales",
        "description": "Variedad de lechuga, parmesano, croutones de pan, pollo a la plancha en tiras y aderezo César de la casa.",
        "ingredients": [
            "Lechuga",
            "Parmesano",
            "Croutones",
            "Pollo",
            "Salsa César"
        ],
        "isPromo": false,
        "name": "Ensalada Cesar",
        "picture": "cesar.jpg",
        "price_dis": 278
    },
    {
        "base_price": 120,
        "category": "Especiales",
        "description": "",
        "isPromo": false,
        "name": "Egg & cheese sandwich",
        "picture": "egg_sandwich.jpg",
        "price_dis": 133
    },
    {
        "base_price": 120,
        "category": "Fritas",
        "description": "",
        "isPromo": false,
        "name": "Porción de Papas Fritas 250g",
        "picture": "papas.jpg",
        "price_dis": 133
    },
    {
        "base_price": 120,
        "category": "Fritas",
        "description": "",
        "isPromo": false,
        "name": "Porción de Aros de Cebolla",
        "picture": "np.jpg",
        "price_dis": 133
    },
    {
        "base_price": 120,
        "category": "Fritas",
        "description": "",
        "isPromo": false,
        "name": "Mix de papas y boniatos",
        "picture": "np.jpg",
        "price_dis": 133
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Champiñones, pimientos, cebolla y aceitunas",
        "isPromo": false,
        "name": "Vegetariana",
        "picture": "pizza_vegetariana.jpg",
        "price_dis": 489
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Tomates, Provolone, rúcula, parmesano y aceite de oliva.",
        "ingredients": [
            "Tomate",
            "Provolone",
            "Rúcula",
            "Parmesano",
            "Aceite de Oliva"
        ],
        "isPromo": false,
        "name": "De La Huerta",
        "picture": "de_la_huerta.jpg",
        "price_dis": 489
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Pollo, Salsa Sweet Chilly (Levemente Picante) y verdeo.",
        "ingredients": [
            "Pollo",
            "Salsa Sweet Chilly",
            "Verdeo"
        ],
        "isPromo": false,
        "name": "Sweet Chilly",
        "picture": "sweet_chilly.jpg",
        "price_dis": 489
    },
    {
        "base_price": 375,
        "category": "Pizzas",
        "description": "Salsa de Tomate",
        "ingredients": [
            "Tomates"
        ],
        "isPromo": false,
        "name": "Tomatito",
        "picture": "tomatito.jpg",
        "price_dis": 417
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Queso crema, Muzzarella, Cheddar,  Parmesano (Sin salsa de tomate)",
        "ingredients": [
            "Queso Crema",
            "Muzzarella",
            "Cheddar",
            "Parmesano"
        ],
        "isPromo": false,
        "name": "4 Quesos",
        "picture": "4_quesos.jpg",
        "price_dis": 489
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Pollo con Salsa BBQ, panceta y cebolla",
        "ingredients": [
            "Salsa BBQ",
            "Pollo",
            "Panceta",
            "Cebolla"
        ],
        "isPromo": false,
        "name": "BBQ chicken bacon",
        "picture": "bbq.jpg",
        "price_dis": 489
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Muzzarella, tomate y albahaca",
        "isPromo": false,
        "name": "Capresse",
        "picture": "pizza_capresse.jpg",
        "price_dis": 489
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Muzzarella, jamón, panceta y pepperoni.",
        "isPromo": false,
        "name": "Forte",
        "picture": "forte.jpg",
        "price_dis": 489
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Jamón en Cubos y Piña Natural.",
        "ingredients": [
            "Jamón",
            "Piña"
        ],
        "isPromo": false,
        "name": "Hawaina",
        "picture": "hawaiana.jpg",
        "price_dis": 489
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Muzzarella y Aceitunas",
        "ingredients": [
            "Muzzarella",
            "Aceitunas"
        ],
        "isPromo": false,
        "name": "Oliva",
        "picture": "oliva.jpg",
        "price_dis": 489
    },
    {
        "base_price": "80",
        "category": "Bebidas",
        "description": " 600 cc",
        "isPromo": false,
        "name": "Sprite Zero 600cc",
        "picture": "sprite_zero.png"
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Muzzarella, provolone, cebolla y carne braseada en IPA",
        "isPromo": false,
        "name": "Philly Cheesesteak",
        "picture": "np.jpg",
        "price_dis": 489
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Sin salsa de Tomate, Muzzarella, cebolla y orégano.",
        "isPromo": false,
        "name": "Fugazzetta",
        "picture": "fugazzetta.jpg",
        "price_dis": 489
    },
    {
        "base_price": 290,
        "category": "Burgers",
        "description": "Doble Smash de carne con cheddar Cebolla Caramelizada Panceta Salsa BBQ",
        "ingredients": [],
        "isPromo": false,
        "name": "Alabama Burger",
        "picture": "alabama.jpg",
        "price_dis": 322
    },
    {
        "base_price": 280,
        "category": "Fritas",
        "description": "Una porción de papas fritas de 350 g con cheddar y panceta.",
        "ingredients": [
            "Queso Cheddar",
            "Panceta"
        ],
        "isPromo": false,
        "name": "Fritas cheddar & panceta",
        "picture": "papas_cheddar.jpg",
        "price_dis": 311
    },
    {
        "base_price": 290,
        "category": "Burgers",
        "description": "Opciones: Garbanzos/ Zanahoria y puerro / Lentejas",
        "isPromo": false,
        "name": "Vegan Burger",
        "picture": "veggie.jpg",
        "price_dis": 322
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Champiñones, Pepperoni y Paprika.",
        "ingredients": [
            "Champiñones",
            "Pepperoni",
            "Paprika"
        ],
        "isPromo": false,
        "name": "Paprika Lovers",
        "picture": "paprika_lovers.jpg",
        "price_dis": 489
    },
    {
        "base_price": 375,
        "category": "Pizzas",
        "description": "Muzzarella y Orégano",
        "ingredients": [
            "Mozarella",
            "Orégano"
        ],
        "isPromo": false,
        "name": "Cheese",
        "picture": "cheese.jpg",
        "suggestions": [],
        "price_dis": 417
    },
    {
        "base_price": 50,
        "category": "Postres",
        "description": "",
        "hidden": false,
        "isPromo": false,
        "name": "Choco-Cookie",
        "picture": "cookie.jpg",
        "price_dis": 56
    },
    {
        "base_price": 80,
        "category": "Postres",
        "description": "",
        "hidden": false,
        "isPromo": false,
        "name": "Doble salchichon relleno",
        "picture": "salchichon.jpg",
        "price_dis": 89
    },
    {
        "base_price": 290,
        "category": "Burgers",
        "description": "Doble Smash de carne con cheddar Lechuga Tomate Mayonesa Salsa Criolla",
        "isPromo": false,
        "name": "Arizona Burger",
        "picture": "arizona.jpg",
        "price_dis": 322
    },
    {
        "base_price": 320,
        "category": "Especiales",
        "description": "De carne o pollo con lechuga, tomate, panceta, papas pay y guarnición opcional de (Papas fritas, aros de cebolla o mix de papas y boniatos)",
        "isPromo": false,
        "name": "Gyro JD",
        "picture": "np.jpg",
        "price_dis": 356
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Panceta y Gotas de Queso Cheddar.",
        "ingredients": [
            "Panceta",
            "Queso Cheddar"
        ],
        "isPromo": false,
        "name": "Deliciosa",
        "picture": "deliciosa.jpg",
        "suggestions": [],
        "price_dis": 489
    },
    {
        "base_price": 290,
        "category": "Burgers",
        "description": "Doble Smash de carne con cheddar Cebolla salteada Pepinillos Mostaza Salsa Ketchup",
        "ingredients": [
            "Queso Cheddar"
        ],
        "isPromo": false,
        "name": "Oklahoma Style",
        "picture": "oklahoma.jpg",
        "price_dis": 322
    },
    {
        "base_price": 80,
        "category": "Bebidas",
        "description": "600 cc",
        "isPromo": false,
        "name": "Coca Cola Regular 600cc",
        "picture": "coca_comun.png"
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Panceta crocante y Huevos fritos.",
        "ingredients": [
            "Panceta",
            "Huevos Fritos"
        ],
        "isPromo": false,
        "name": "Siesta",
        "picture": "siesta.jpg",
        "suggestions": [],
        "price_dis": 489
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Pepperoni premium, queso muzzarella y orégano.",
        "ingredients": [
            "Pepperoni",
            "Muzzarella",
            "Orégano"
        ],
        "isPromo": false,
        "name": "Peroni",
        "picture": "peroni.jpg",
        "suggestions": [],
        "price_dis": 489
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "salsa de tomate, muzzarella, cebolla caramelizada, queso azul y mix de nueces con caramelo",
        "isPromo": false,
        "name": "Lulita's",
        "picture": "lullitas.jpg",
        "suggestions": [],
        "price_dis": 489
    },
    {
        "base_price": 190,
        "category": "Fainá",
        "description": "Muzzarella, tomate, rúcula, parmesano y aceite de oliva.",
        "ingredients": [
            "Muzarella",
            "Tomate",
            "Rúcula",
            "Parmesano",
            "Aceite de Oliva"
        ],
        "isPromo": false,
        "name": "Fainá de la Huerta",
        "picture": "faina_huerta.jpg",
        "price_dis": 211
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Peras, Roquefort, Panceta y Nuez. (Sin salsa de tomate)",
        "ingredients": [
            "Pera",
            "Roquefort",
            "Panceta",
            "Nuez"
        ],
        "isPromo": false,
        "name": "Natalio",
        "picture": "natalio.jpg",
        "suggestions": [],
        "price_dis": 489
    },
    {
        "base_price": 130,
        "category": "Fainá",
        "description": "",
        "ingredients": [
            "Muzarella"
        ],
        "isPromo": false,
        "name": "Fainá con Muzza",
        "picture": "faina_muzza.jpg",
        "price_dis": 144
    },
    {
        "base_price": 290,
        "category": "Burgers",
        "description": "Pechuga crispy, rúcula, tomate, parmesano y aderezo especial.",
        "ingredients": [
            "Queso Cheddar"
        ],
        "isPromo": false,
        "name": "Indyana Crispy Chicken",
        "picture": "indyanna.jpg",
        "price_dis": 322
    },
    {
        "base_price": 290,
        "category": "Burgers",
        "description": "Doble smash de carne con muzzarella, morrones confitados, huevo frito y aderezo a elección",
        "ingredients": [
            "Queso Cheddar"
        ],
        "isPromo": false,
        "name": "California Burger",
        "picture": "indyanna.jpg",
        "price_dis": 322
    },
    {
        "base_price": 290,
        "category": "Burgers",
        "description": "Doble smash de carne con panceta, medallon de provolone y aderezo inglés.",
        "ingredients": [
            "Queso Cheddar"
        ],
        "isPromo": false,
        "name": "Miami Chesse",
        "picture": "np.jpg",
        "price_dis": 322
    },
    {
        "base_price": 80,
        "category": "Bebidas",
        "description": "600 cc",
        "isPromo": false,
        "name": "Coca Cola Light 600cc",
        "picture": "coca_light.png"
    },
    {
        "base_price": 160,
        "category": "Bebidas",
        "description": "1.5lts",
        "isPromo": false,
        "name": "Gaseosas 1.5lts",
        "picture": "np.jpg"
    },
    {
        "base_price": 320,
        "category": "Especiales",
        "description": "De carne o pollo con lechuga, tomate cebolla, mayonesa y guarnición opcional de (Papas fritas, aros de cebolla o mix de papas y boniatos)",
        "isPromo": false,
        "name": "Wrap JD + Acompañamiento",
        "picture": "np.jpg",
        "price_dis": 356
    },
    {
        "base_price": 440,
        "category": "Pizzas",
        "description": "Jamón en cubos y pimientos asados.",
        "ingredients": [
            "Jamón",
            "Pimientos Asados"
        ],
        "isPromo": false,
        "name": "Boston",
        "picture": "boston.jpg",
        "suggestions": [],
        "price_dis": 489
    },
    {
        "base_price": 110,
        "category": "Fainá",
        "description": "",
        "isPromo": false,
        "name": "Fainá",
        "picture": "faina.jpg",
        "price_dis": 122
    }
]

export const categoriesJD: categoryType[] = [
    {
        name: "Pizzas",
        slug: "pizzas",
        order: 1,
        image: "",
        products: [
        ]
    },
    {
        name: "Burger",
        slug: "burgers",
        order: 2,
        image: "",
        products: [
        ]
    },
    {
        name: "Fritas",
        slug: "fritas",
        order: 3,
        image: "",
        products: [
        ]
    },
    {
        name: "Fainá",
        slug: "faina",
        order: 4,
        image: "",
        products: [
        ]
    },
    {
        name: "Especiales",
        slug: "especiales",
        order: 5,
        image: "",
        products: [
        ]
    },
    {
        name: "Bebidas",
        slug: "bebidas",
        order: 6,
        image: "",
        products: [
        ]
    },

]